import { createSlice } from "@reduxjs/toolkit";

const tabData = [];
for (let i = 0; i < 169; i++) {
  tabData.push(i + 1);
}

const preflopSlice = createSlice({
  name: "preFlop",
  initialState: {
    result: [],
    emptyCards: tabData,
    recentPayload: {},
  },
  reducers: {
    setPreflopResult: (state, { payload }) => {
      state.result = payload?.result;
      state.recentPayload = payload?.recentPayload;
    },
  },
});
export const { setPreflopResult } = preflopSlice.actions;
export default preflopSlice.reducer;
